import AuthProvider from "../infrastructure/authProvider";
import DataProvider, { buildFilter, getHttpClient as getRealHttpClient } from "../infrastructure/dataProvider";
import mockAuthProvider from "../infrastructure/mockAuthProvider";
import mockDataProvider, { getHttpClient as getMockHttpClient } from "../infrastructure/mockDataProvider";
import { DataProvider as DataProvideType } from "ra-core";
import { stringify } from "query-string";

// copy from ra-core
export interface Sort {
  field: string;
  order: string;
}
export interface Filter {
  [k: string]: any;
}
export interface Pagination {
  page: number;
  perPage: number;
}

// Fetch like Interface
// 本家fetchの制限をゆるくしたもの
type ResponseLike = {
  status: number;
  headers: Headers;
  body: any;
  json: any;
};
export type FetchLike = (url: string, options?: any) => Promise<ResponseLike>;

let httpClient: FetchLike | null = null;
let dataProvider: DataProvideType | null = null;

export function getApiBase() {
  return "/buyer-api/v1";
}

export function getHttpClient() {
  if (httpClient === null) {
    if (import.meta.env.VITE_MOCK_API === "true") {
      httpClient = getMockHttpClient();
    } else {
      httpClient = getRealHttpClient();
    }
  }
  return httpClient;
}

export function getAuthProvider() {
  if (import.meta.env.VITE_MOCK_API === "true") {
    return mockAuthProvider;
  }
  return AuthProvider;
}

export function getDataProvider() {
  if (dataProvider === null) {
    if (import.meta.env.VITE_MOCK_API === "true") {
      dataProvider = mockDataProvider(getApiBase(), getHttpClient());
    } else {
      dataProvider = DataProvider(getApiBase(), getHttpClient());
    }
  }
  return dataProvider;
}

// 全部の要素を取得する独自関数
// TODO: あとでページングして分割して取得するようにする
export const getListAll = (
  resource: string,
  params?: {
    sort: Sort;
    filter: any;
  }
) => {
  const apiUrl = getApiBase();
  const httpClient = getHttpClient();

  let url = `${apiUrl}/${resource}`;
  if (params) {
    const { field, order } = params.sort;
    const filters = buildFilter(params.filter);
    const query: any = {
      _sortField: field,
      _sortDir: order,
      ...filters,
    };
    url = `${url}?${stringify(query)}`;
  }

  return httpClient(url).then((response) => {
    const { headers, json } = response;
    const count = parseInt(headers.get("x-total-count") + "", 10);
    const total = Number.isNaN(count) ? 0 : count;
    return {
      data: json,
      total,
    };
  });
};

// 空白の場合にNullが送られるのを抑制する
export const preventSendNull = (value: any) => value;
